import { createSlice } from '@reduxjs/toolkit';

export const publisherContextInitialState = {
  publisherName: '',
};

// Then, handle actions in your reducers:
const publisherContextSlice = createSlice({
  name: 'publisherContext',
  publisherContextInitialState,
  reducers: {
    // standard reducer logic, with auto-generated action types per reducer
    publisherContextSetNameState: (state, { payload }) => {
      state.publisherName = payload;
    },
  },
});

// actions generated from the slice, TODO: remove start,success,fail
export const { publisherContextSetNameState } = publisherContextSlice.actions;

// The reducer
export const publisherContextReducer = publisherContextSlice.reducer;
